import type { TermsValue } from '@b-stock/account-api-client'

import appConfig from '@config/config'
import { get, post } from '@helpers/xhr'

const { api } = appConfig

// Per call, so a hung terms service can't stall login (recordTermsAcceptance
// makes at most two serial calls)
const TIMEOUT_MS = 5_000

export default {
  async getAcceptedPolicies({ id }: { id: string }) {
    const { data } = await get<Record<string, TermsValue>>(
      api.terms.accepted,
      null,
      { entities: { id }, timeout: TIMEOUT_MS }
    )
    return data
  },

  async acceptPolicy({ id, policy }: { id: string; policy: string }) {
    const { data } = await post<Record<string, TermsValue>>(
      api.terms.accept,
      {},
      { entities: { id, policy }, timeout: TIMEOUT_MS }
    )
    return data
  },
}
